module.exports = __webpack_public_path__ + "img/phillips-smart-led.fecf70c3.jpg";